import axios from 'axios';
const API_URL = process.env.REACT_APP_API_ENDPOINT;

/**
 * Lấy danh sách tính năng để hiển thị trong dropdown filter
 * API: GET /json/api/dashboard/tuvi-report/feature-names
 */
export const getFeatureNames = async () => {
      const res = await axios.get(`${API_URL}tuvi-report/feature-names`);
      return res;
};

/**
 * Lấy danh sách đối tác để hiển thị trong dropdown filter
 * API: GET /json/api/dashboard/tuvi-report/partners
 * Response data: [{ id: '<identifier>', name: 'Lịch Việt' }, ...] — id '' = Không xác định
 */
export const getPartners = async () => {
      const res = await axios.get(`${API_URL}tuvi-report/partners`);
      return res;
};

/**
 * Lấy dữ liệu thống kê dạng bảng
 * API: POST /json/api/dashboard/tuvi-report/data-statistics
 * @param {Object} values - { featureNames, partnerIds, startTime, endTime, metricIds, dimensionIds }
 */
export const getDataStatistics = async (values) => {
      const res = await axios.post(`${API_URL}tuvi-report/data-statistics`, values);
      return res;
};

/**
 * Lấy dữ liệu thống kê cho biểu đồ
 * API: POST /json/api/dashboard/tuvi-report/graphical-statistics
 * @param {Object} values - { featureNames, partnerIds, startTime, endTime, metricIds, dimensionIds }
 */
export const getGraphicalStatistics = async (values) => {
      const res = await axios.post(`${API_URL}tuvi-report/graphical-statistics`, values);
      return res;
};

/**
 * Xuất file Excel
 * API: POST /json/api/dashboard/tuvi-report/export
 * @param {Object} values - { featureNames, partnerIds, startTime, endTime, metricIds, dimensionIds }
 */
export const exportExcel = async (values) => {
      const response = await axios({
            url: `${API_URL}tuvi-report/export`,
            method: 'POST',
            responseType: 'blob',
            headers: {
                  'Content-Type': 'application/json',
            },
            data: values,
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = 'tuvi-report.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
};
